import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { extensionIdToAnalyticsAttributes } from './extensionIdToAnalyticsAttributes';

export const ForgeUIExtensionAnalyticsContext = ({
	extensionId,
	localId,
	children,
}: {
	children: React.ReactNode;
	extensionId: string;
	localId: string;
}): React.JSX.Element => {
	return (
		<AnalyticsContext
			data={{
				forgeUIAttributes: {
					localId,
					...extensionIdToAnalyticsAttributes(extensionId),
				},
			}}
		>
			{children}
		</AnalyticsContext>
	);
};
